"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuerySwitch = void 0;
var React = require("react");
var react_router_1 = require("react-router");
var matches_query_1 = require("./matches-query");
/**
 * Example Usage:
 *
 * <QuerySwitch>
 *   <QueryRoute query={{"someKey": "someValue"}}>
 *     <span>Foo</span>
 *   </QueryRoute>
 *   <QueryRoute query={"someKey"}> //Any Value
 *     <span>Bar</span>
 *   </QueryRoute>
 * </QuerySwitch>
 *
 * In this case, only Foo will render.
 * Without the QuerySwitch, both Foo and Bar will render
 */
var QuerySwitch = function (props) {
  var location = (0, react_router_1.useLocation)();
  var search = props.search || location.search;
  var match = false;
  var child;
  React.Children.forEach(props.children, function (element) {
    if (match === false && React.isValidElement(element)) {
      var query = element.props.query;
      child = element;
      match = (0, matches_query_1.matchesQuery)(search, query);
    }
  });
  return match ? React.cloneElement(child, {
    queryMatch: true,
    search: search
  }) : null;
};
exports.QuerySwitch = QuerySwitch;